import { render, staticRenderFns } from "./changePassowrd.vue?vue&type=template&id=89ca8b94"
import script from "./changePassowrd.vue?vue&type=script&lang=js"
export * from "./changePassowrd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports